export default {
    computed: {
        initial: function (){
            let initial = ""
            initial += this.main_info.creator.fio.split(' ')[1][0];
            initial +="."
            initial += this.main_info.creator.fio.split(' ')[2][0];
            initial +="."
            initial += this.main_info.creator.fio.split(' ')[0];

            return initial;
        },
        TotalLoad: function (){
            let period = [...new Set(this.overload.map(item => item.period))];
            let load = [];
            period.forEach(per => {
                load.push({
                    key: per,
                    value: this.overload.filter(item => item.period === per)
                })
            });
            return load;
        },
        provisor: function (){
            this.select_options.departments.forEach(head => {
                if (head.name === this.main_info.grad_dep){
                    this.main_info.provisor = head.head;
                }
            })
            return this.main_info.provisor
        },
        UK: function (){
            return this.competitions[this.main_info.speciality_code].UK
        },
        OPK: function (){
            return this.competitions[this.main_info.speciality_code].OPK
        },
        table_size: function () {
            if (this.main_info.speciality_code.split('.')[1] !== '02'){
                return [2, 9, 16]
            }
            else {
                return [2, 11, 18]
                //return [1, 6, 13]
            }
        },
        spo: function () {
            if (this.main_info.speciality_code.split('.')[1] !== '02'){
                return true
            }
            else {
                return false
            }
        },

        ministry: function (){
            if (['01.03.02','09.03.01','09.03.02','09.03.04','13.03.01','13.03.02','24.03.01','29.03.05','39.03.01','39.03.02','41.03.01','42.03.01','42.03.02','43.03.02','43.03.03','44.03.01','44.03.02','44.03.05','45.03.03','01.04.02','09.04.04','13.04.02','39.04.02','41.04.01','42.04.01','43.04.02','44.04.01','44.04.02','09.02.07','10.02.04','18.02.12','38.02.01'].includes(this.main_info.speciality_code)){
                return ['Министерства образования и науки Российской Федерации', 'Министерством образования и науки РФ']
            }
            else if (this.main_info.speciality_code.split('.')[1] === '02'){
                return ['Министерства просвещения Российской Федерации', 'Министерством просвещения РФ']
            }
            else{
                return ['Министерства науки и высшего образования Российской Федерации', 'Министерством науки и высшего образования РФ']
            }
        }
    }
}